/**
 * Заголовок карточки репоста — по СОДЕРЖАНИЮ приёма, а не по случайной позиции.
 *
 * ЗАЧЕМ (10.09.2026, поймал Слава). Заголовок брался как `items[0].name` —
 * то есть первая позиция в том порядке, в каком её вернула модель. Порядок там
 * произвольный, и тарелка с тремя куриными голенями, хлебом и салатом
 * подписалась «2 куска хлеба».
 *
 * По базе того приёма: голени 240 г / 430 ккал, хлеб 80 г / 200 ккал,
 * салат 200 г / 180 ккал. Главное блюдо очевидно, а в заголовок попало
 * самое мелкое. На публичной картинке это не косметика: продукт выглядит
 * так, будто он не понял, что на фото.
 *
 * ПОЧЕМУ СОРТИРОВКА ПО КАЛОРИЯМ, А НЕ ПО ВЕСУ. Приложение про калории, и
 * «чем этот приём был» определяется вкладом в дневную норму, а не массой.
 * Двести грамм огурцов не делают приём «огурцами», а сто грамм шоколада —
 * делают. На этом приёме обе меры дали бы один ответ, но расходятся они
 * именно на таких случаях.
 *
 * ПОЧЕМУ НЕ ОДНО НАЗВАНИЕ, А НЕСКОЛЬКО. Карточка — витрина продукта, и
 * перечисление показывает главное: приложение разобрало ВСЮ тарелку, а не
 * одно блюдо. Ради этого её и репостят.
 */

export type TitleItem = { name?: string | null; calories?: number | string | null };

/**
 * Предел длины. Кегль заголовка ужимается с 44 до 30 пикселей, и на 30
 * в ширину карточки влезает примерно 56 символов. Берём с запасом: если
 * не влезет и на минимальном кегле, текст полезет за край — а обрезанное
 * название на картинке, которую понесут наружу, это брак.
 */
const MAX_LEN = 52;
const SEP = ', ';

export function mealTitle(items: TitleItem[]): string {
  const named = (items ?? [])
    .map((i) => ({ name: String(i?.name ?? '').trim(), cal: Number(i?.calories) || 0 }))
    .filter((i) => i.name.length > 0)
    .sort((a, b) => b.cal - a.cal);

  if (named.length === 0) return 'Приём пищи';

  // Набираем столько названий, сколько помещается, начиная с самого весомого.
  const shown: string[] = [];
  for (const item of named) {
    const next = shown.length ? shown.join(SEP) + SEP + item.name : item.name;
    if (shown.length > 0 && next.length > MAX_LEN) break;
    shown.push(item.name);
  }

  const rest = named.length - shown.length;
  const head = shown.join(SEP);

  // Остаток не прячем: «и ещё 2» честно говорит, что распознано больше,
  // чем поместилось в строку. Молчать об этом — занижать собственную работу.
  return rest > 0 ? `${head} +${rest}` : head;
}
